import { Directive, HostBinding, Input } from '@angular/core';
import { ContactType } from 'src/app/core/models/common/contact.model';

@Directive({
    selector: '[appContactTypeIcon]',
    standalone: false
})
export class ContactTypeIconDirective {

  @Input() set type(type: ContactType) {
    this.iconType = this.getIconType(type)
  }

  @HostBinding('innerHTML') iconType = '';

  private getIconType(type: ContactType): string {
    switch (type) {
      case ContactType.Phone: return 'phone_iphone'
      case ContactType.Email: return 'email'
      default: return ''
    }
  }
}
